import { RouteDefinition } from "@solidjs/router";
import { lazy } from "solid-js";

export const notificationRoutes: RouteDefinition[] = [
  {
    path: "/notifications",
    children: [
      {
        path: "/",
        component: lazy(
          () => import("../components/notification/NotificationsList.js"),
        ),
      },
    ],
  },
];
